import React, { useEffect, useState } from "react";
import '../../assets/css/style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useLocation, useNavigate } from "react-router-dom";
import { useUser } from "../UserContext";
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import Loader from "../Loader";
const Sidebar = ({ setLoading }) => {
  const user = useUser();
  const UserData = user?.user;
  const SusbcriptionData = user?.subscriptionStaff;
  const employeeId = UserData?.user?.facility_user?.employee?.id;
  const userRole = UserData?.user?.role?.trim().toLowerCase();
  const isTrainingUser = userRole === "trainings_user";
  const [isScrolled, setIsScrolled] = useState(false);
  const [subMenu, setSubMenu] = useState(false)
  const [apiSubscriptionData, setApiSubscriptionData] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const handleScroll = (e) => {
    const scrollTop = e.target.scrollTop;
    setIsScrolled(scrollTop > 0);
  };

  const handleSubMenu = () => {
    setSubMenu(!subMenu)
  }

  const permissions = {
    residents: {
      dashboard: UserData?.facility?.is_resident_module_enabled &&
        UserData?.user?.role !== 'examiner' &&
        UserData?.user?.facility_user?.can_see_residents,

      list: UserData?.facility?.is_resident_module_enabled &&
        UserData?.user?.facility_user?.can_see_residents &&
        UserData?.user?.role !== 'trainings_user',

      add: UserData?.facility?.is_resident_module_enabled &&
        UserData?.user?.facility_user?.can_see_residents &&
        UserData?.user?.role !== 'trainings_user' &&
        UserData?.user?.role !== 'examiner',

      admission: UserData?.facility?.is_resident_module_enabled &&
        UserData?.user?.facility_user?.can_see_residents &&
        UserData?.user?.role !== 'trainings_user' &&
        UserData?.user?.role !== 'examiner',
    },

    staff: {
      dashboard: UserData?.user?.role === 'trainings_user' ||
        (UserData?.facility?.is_staff_module_enabled && UserData?.user?.role !== 'examiner'),

      list:
        UserData?.user?.facility_user?.can_see_staff &&
        UserData?.user?.role !== 'examiner' &&
        UserData?.user?.role !== 'trainings_user',

      add:
        UserData?.user?.facility_user?.can_see_staff &&
        UserData?.user?.role !== 'examiner' &&
        UserData?.user?.role !== 'trainings_user',

      schedule:
        UserData?.user?.facility_user?.can_see_staff &&
        UserData?.user?.role !== 'examiner' &&
        UserData?.user?.role !== 'trainings_user',

      courses:
        UserData?.user?.facility_user?.can_see_staff &&
        UserData?.user?.role !== 'examiner' &&
        UserData?.user?.role !== 'trainings_user', // Removed `manager` restriction for consistency

      customTrainings:
        UserData?.user?.facility_user?.can_see_staff &&
        UserData?.user?.role !== 'examiner' &&
        UserData?.user?.role !== 'trainings_user',
    },

    account: {
      creditCard: UserData?.user?.role !== 'examiner' &&
        UserData?.user?.role !== 'trainings_user' &&
        SusbcriptionData?.has_stripe_id === false, // Aligns with `showPayNowButton`

      facility: UserData?.user?.role !== 'examiner' &&
        UserData?.user?.role !== 'trainings_user',
    }
  };

  const residentsPermissions = permissions.residents;
  const staffPermissions = permissions.staff;
  const accountPermissions = permissions.account;

  // Check if at least one resident permission is available
  const hasResidentPermissions = Object.values(residentsPermissions).some(Boolean);
  const hasStaffPermissions = Object.values(staffPermissions).some(Boolean);
  const hasAccountPermissions = Object.values(accountPermissions).some(Boolean);

  const fetchSubscriptions = async () => {
    setLoading(true)
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/subscriptions/all/`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Token ${localStorage.getItem('token')}`, // agar auth required ho
          },
        }
      );

      if (!response.ok) {
        setLoading(false);
        throw new Error('Failed to fetch subscriptions');
      }

      const data = await response.json();
      setApiSubscriptionData(data?.subscriptions)
    } catch (error) {
      setLoading(false);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (location.pathname === '/dashboard' || location.pathname === '/employeelist' || location.pathname === '/add-employee' || location.pathname === '/courses' || location.pathname === '/manage-task') {
      fetchSubscriptions();
    }
  }, []);
  useEffect(() => {

    if (!Array.isArray(apiSubscriptionData) || apiSubscriptionData?.length === 0) {
      return;
    }

    const {
      stripe_customer_id,
      stripe_id,
      has_stripe_id,
    } = SusbcriptionData;

    const filterStaffPlus = apiSubscriptionData?.filter((item) => item?.plan_name === 'Staff Plus' && item?.module === 'staff')
    if (!stripe_customer_id && !stripe_id && !filterStaffPlus) {
      navigate('/trial-cancel');
      return;
    }
    const hasActiveOrTrialing = filterStaffPlus?.some(sub =>
      ['active', 'trialing'].includes(sub.status)
    );

    if ((has_stripe_id || has_stripe_id === undefined) && !hasActiveOrTrialing) {
      navigate('/subscriptionplan');
      return;
    }
    if (has_stripe_id === false && !hasActiveOrTrialing) {
      navigate('/trial-cancel');
      return;
    }

  }, [SusbcriptionData, apiSubscriptionData]);

  return (
    <>

      <PerfectScrollbar onScroll={handleScroll} className="custom-scrollbar" style={{ background: "linear-gradient(180deg,rgba(11, 82, 67, 1) 4%, rgba(18, 153, 126, 1) 100%)" }}>
        <div className={`nav-wrapper ${isScrolled ? 'scrolled' : ''}`}>
          <ul
            id="nav"
            className="nav"
            data-slim-scroll
            data-collapse-nav
            data-highlight-active
          >

            {hasResidentPermissions && (
              <li className="nav-header ">
                <span>Residents</span>
              </li>
            )}

            {/* Resident Dashboard */}
            {residentsPermissions.dashboard && <li className="{permissions.residentNavClass}">
              <a href="/resident-dashboard" hide-off-canvas="true">
                <i className="nav-icon fa fa-dashboard" />
                <span>Resident Dashboard</span>
              </a>
            </li>
            }

            {/* Resident List */}
            {residentsPermissions.list &&
              <li className="{permissions.residentNavClass}">
                <a href="/residentlist" hide-off-canvas="true">
                  <i className="nav-icon fa fa-users" />
                  <span>Resident List</span>
                </a>
              </li>
            }

            {/* Resident Add */}
            {residentsPermissions.add &&
              <li className="{permissions.residentNavClass}">
                <a href="/add-resident" hide-off-canvas="true">
                  <i className="nav-icon fa fa-user-plus" />
                  <span>Add Resident</span>
                </a>
              </li>
            }

            {/* Resident Admissions */}
            {residentsPermissions.admission &&
              <li className="{permissions.residentNavClass}">
                <a href="/admission-log" hide-off-canvas="true">
                  <i className="nav-icon fa fa-users" />
                  <span>Admission / Discharge Log</span>
                </a>
              </li>
            }


            {/* <li className="nav-header">
          <span>Staffing</span>
        </li>


        {permissions.staff.dashboard && (
          <li>
            <a href="/dashboard" hide-off-canvas="true">
              <i className="nav-icon fa fa-dashboard" />
              <span>Employee Dashboard</span>
            </a>
          </li>
        )}

        {permissions.staff.list && (
          <li>
            <a href="/employeelist" hide-off-canvas="true">
              <i className="nav-icon fa fa-users" />
              <span>Employee List</span>
            </a>
          </li>
        )}

        {permissions.staff.add && (
          <li>
            <a href="/add-employee" hide-off-canvas="true">
              <i className="nav-icon fa fa-user-plus" />
              <span>Add Employee</span>
            </a>
          </li>
        )}

        {permissions.staff.schedule && (
          <li>
            <a href="/training-events" hide-off-canvas="true">
              <i className="nav-icon fa fa-book" />
              <span>Scheduled Trainings</span>
            </a>
          </li>
        )}
        {permissions.staff.courses && (
          <li>
            <a href="/courses" hide-off-canvas="true">
              <i className="nav-icon fa fa-graduation-cap" />
              <span>Courses</span>
            </a>
          </li>
        )}
        {permissions.staff.customTrainings && (
          <li>
            <a
              href="/tasktypes"
              data-staff-subscription-required="true"
              hide-off-canvas="true"
            >
              <i className="nav-icon fa fa-plus" />
              <span>Custom Trainings</span>
            </a>
          </li>
        )}
 */}

            {hasStaffPermissions &&
              <li className="nav-header">
                <span>Staffing</span>
              </li>
            }



            {staffPermissions.dashboard && (
              <>
                <li>
                  <a href="/dashboard" hide-off-canvas="true">
                    <i className="nav-icon fa fa-dashboard" />
                    <span>Employee Dashboard</span>
                  </a>
                </li>

                {isTrainingUser && (
                  <li>
                    <a href={`/employeeview/${employeeId}`} hide-off-canvas="true">
                      <i className="nav-icon fa fa-graduation-cap" />
                      <span>Training Records</span>
                    </a>
                  </li>
                )}
              </>
            )}
            {staffPermissions.list && (
              <li>
                <a href="/employeelist" hide-off-canvas="true">
                  <i className="nav-icon fa fa-users" />
                  <span>Employee List</span>
                </a>
              </li>
            )}

            {staffPermissions.add && (
              <li>
                <a href="/add-employee" hide-off-canvas="true">
                  <i className="nav-icon fa fa-user-plus" />
                  <span>Add Employee</span>
                </a>
              </li>
            )}

            {/* {staffPermissions.schedule && (
            <li>
              <a href="/training-events" hide-off-canvas="true">
                <i className="nav-icon fa fa-book" />
                <span>Scheduled Trainings</span>
              </a>
            </li>
          )} */}
            {staffPermissions.courses && (
              <li>
                <a href="/courses" hide-off-canvas="true">
                  <i className="nav-icon fa fa-graduation-cap" />
                  <span>Courses</span>
                </a>
              </li>
            )}

            {staffPermissions.courses && (
              <li>
                <a href="/manage-task" hide-off-canvas="true">
                  <i className="nav-icon fa fa-graduation-cap" />
                  <span>Manage Courses</span>
                </a>
              </li>
            )}


            {/* {staffPermissions.customTrainings && (
            <li>
              <a
                href="/tasktypes"
                data-staff-subscription-required="true"
                hide-off-canvas="true"
              >
                <i className="nav-icon fa fa-plus" />
                <span>Custom Trainings</span>
              </a>
            </li>
          )} */}

            {/* {hasAccountPermissions && */}
            <li className="nav-header">
              <span>Account</span>
            </li>
            {/* } */}


            {accountPermissions.creditCard && (
              <li>
                <a
                  href="/subscription-staff/?updateTrial=true"
                  hide-off-canvas="true"
                >
                  <i className="nav-icon fa-regular fa-money-bill-1"></i>
                  <span>Add credit card</span>
                </a>
              </li>
            )}

            {accountPermissions.facility && (
              <li>
                <a hide-off-canvas="true" onClick={handleSubMenu} className="cursor-pointer !flex flex-row justify-between items-center">
                  <div>
                    <i className="nav-icon fa-solid fa-building" />
                    <span>Facility Details</span>
                  </div>
                  <div>
                    {!subMenu ? <i class="fa-solid fa-chevron-down"></i> : <i class="fa-solid fa-chevron-up"></i>}
                  </div>
                </a>
                {subMenu && (
                  <>
                    <a href="/facililitydetail " hide-off-canvas="true" className="hover:!border border-emrald-700 hover:bg-emerald-700 rounded-lg" >
                      <i className="nav-icon fa-solid fa-house-medical !text-lg"></i>
                      <span className="text-lg">Facility </span>
                    </a>
                    <a href="/subscriptionplan" hide-off-canvas="true" className="hover:!border border-emrald-700 hover:bg-emerald-700 rounded-lg ">
                      <i className="nav-icon fa-regular fa-credit-card !text-lg"></i>
                      <span className="text-lg">Subscription</span>
                    </a>
                    <a href="/billing" hide-off-canvas="true" className="hover:!border border-emrald-700 hover:bg-emerald-700 rounded-lg ">
                      <i className="nav-icon fa-solid fa-store !text-lg"></i>
                      <span className="text-lg">Billing</span>
                    </a>
                    {/* <a href="/invoice" hide-off-canvas="true" className="hover:!border border-emrald-700 hover:bg-emerald-700 rounded-lg ">
                    <i class="nav-icon fa-solid fa-store !text-lg"></i>
                    <span className="text-lg">Invoices</span>
                  </a> */}
                  </>
                )}
              </li>
            )}

            {UserData?.facility?.bought_ebook &&
              <li>
                <a
                  className="{permissions.ahcaxietyClass}"
                  href="http://alfboss.com/wp-content/uploads/2018/07/Cure-Your-AHCAXIETY-ebook_06.pdf"
                  hide-off-canvas="true"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="nav-icon fa fa-bookmark" />
                  <span>Curing AHCAxiety</span>
                </a>
              </li>
            }

            {UserData?.user?.role !== 'examiner' &&
              <li>
                <a href="/ahca-regulations" hide-off-canvas="true">
                  <i className="nav-icon fa-regular fa-square-check" />
                  <span>AHCA Regulations</span>
                </a>
              </li>
            }


            <li>
              <a
                href="/tutorial"
                hide-off-canvas="true"
                title="Go to video tutorials"
              >
                <i className="nav-icon fa fa-film" />
                <span>Tutorial Videos</span>
              </a>
            </li>

            <li>
              <a href="https://alfboss.com/faq/" target="_blank" rel="noopener noreferrer" hide-off-canvas="true">
                <i className="nav-icon fa fa-question-circle" />
                <span>FAQs</span>
              </a>
            </li>
          </ul>
        </div>
      </PerfectScrollbar>
    </>
  );

};

export default Sidebar;
